import { CacheProvider } from '@emotion/react';
import * as React from 'react';

const createEmotionCache = require('./utils/create-emotion-cache');

const cache = createEmotionCache('healthmarkets22');
// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => (
    // eslint-disable-next-line react/jsx-filename-extension
    <CacheProvider value={cache}>{element}</CacheProvider>
);
